import React, { useMemo } from 'react';
import { useDataValidationTableColumns } from './useDataValidationTableColumns';
import { Table, useTable } from '@cherre-frontend/ui';
import { isValidationRuleActive } from '../../../../helpers/isValidationRuleActive.helper';
import { RuleLibraryItem } from '../../../../providers/DataValidationV2Provider';

interface DataValidationTableProps {
  ruleLibraryItems: RuleLibraryItem[];
}

export const useSortedDataValidation = (
  ruleLibraryItems: RuleLibraryItem[]
): RuleLibraryItem[] => {
  return useMemo(
    () =>
      [...ruleLibraryItems].sort((a, b) => {
        const aType = a.ruleLibraryItemRef?.rliType;
        const bType = b.ruleLibraryItemRef?.rliType;

        if (aType === 'CUSTOMIZABLE' && bType === 'PRECONFIGURED') {
          return -1;
        } else if (aType === 'PRECONFIGURED' && bType === 'CUSTOMIZABLE') {
          return 1;
        } else if (isValidationRuleActive(a) && !isValidationRuleActive(b)) {
          return -1;
        } else if (!isValidationRuleActive(a) && isValidationRuleActive(b)) {
          return 1;
        }
        return 0;
      }),
    [ruleLibraryItems]
  );
};

export const DataValidationTable = ({
  ruleLibraryItems: data,
}: DataValidationTableProps) => {
  const columns = useDataValidationTableColumns();

  const sortedData = useSortedDataValidation(data);

  const table = useTable({
    data: sortedData,
    columns,
    skeletonRowCount: 5,
    enableSelectAll: false,
    enableRowActions: false,
    enableRowSelection: false,
    enableBottomToolbar: true,
    enablePagination: true,
    manualPagination: false,
    enableMultiSort: false,
    positionActionsColumn: 'last',
    layoutMode: 'grid',
    manualSorting: false,
    initialState: { pagination: { pageSize: 25, pageIndex: 0 } },
    muiTablePaperProps: {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        flex: 1,
      },
      elevation: 0,
    },
    muiTableContainerProps: { sx: { flex: 1 } },
  });

  return <Table table={table} />;
};
